import { Header2, PageTemplateContent } from 'app/common/templates-next/page-template'
import ControlsBar from 'app/common/ui-next/controls-bar'
import { PlainDatePickerDouble } from 'app/common/ui-next/plain-date-picker'
import { PlainDateSwitcherDouble } from 'app/common/ui-next/plain-date-switcher'
import { useCurrencySign } from 'app/common/components-next/currency'
import Sticky from 'app/common/templates-next/sticky'

import { StatementsLoading } from './StatementsLoading'
import { StatementsTable } from './statementsTable'


type Props = {
  studentID: string
  supplierID: string | null
  periodFrom: string | null
  periodTo: string | null
  periodFormat: string
  onRedirectPeriod: (from: string | null, to: string | null, format: string) => void
  onRedirectWithdrawToParent: (ID: string) => void
}

export const Statements = ({
  studentID,
  supplierID,
  periodFrom,
  periodTo,
  periodFormat,
  onRedirectPeriod,
  onRedirectWithdrawToParent,
}: Props) => {
  const currency = useCurrencySign()

  if (!supplierID) {
    return <StatementsLoading />
  }

  return (
    <>
      <Sticky>
        {ref => (
          <PageTemplateContent reference={ref}>
            <ControlsBar right>
              <Header2 skipMargin>{'Заявки на вывод компенсации'}</Header2>
              {periodFrom
                && periodTo
                && <PlainDateSwitcherDouble
                  dateFrom={periodFrom}
                  dateTo={periodTo}
                  dateFormat={periodFormat}
                  onDateChange={onRedirectPeriod}
                >
                  <PlainDatePickerDouble
                    dateFrom={periodFrom}
                    dateTo={periodTo}
                    dateFormat={periodFormat}
                    closeOnClick={false}
                    onChange={onRedirectPeriod}
                  />
                </PlainDateSwitcherDouble>}
            </ControlsBar>
          </PageTemplateContent>
        )}
      </Sticky>

      {periodFrom
        && periodTo
        && <PageTemplateContent skipPadding>
          <StatementsTable
            studentID={studentID}
            supplierID={supplierID}
            periodFrom={periodFrom}
            periodTo={periodTo}
            periodFormat={periodFormat}
            currency={currency}
            onRedirectWithdrawToParent={onRedirectWithdrawToParent}
          />
        </PageTemplateContent>}
    </>
  )
}
